import { Badge, Page, SearchInput } from '@dixa/lib-shared-habla';

import { useBansByIp } from 'hooks/useBans';

import { BannedIpsTable } from './bannedIpsTable';

export function BannedIpsTab(): JSX.Element {
  const {
    total,
    items,
    asyncStatus,
    hasPreviousPage,
    hasNextPage,
    previousPage,
    nextPage,
    refreshItems,
    changeParams,
    params,
  } = useBansByIp({});

  return (
    <Page.Section
      title="Ban history"
      titleMeta={
        total && (
          <Badge size="small" variant="secondary">
            {total}
          </Badge>
        )
      }
      controls={
        <SearchInput
          onSubmit={(value) => changeParams({ search: value })}
          onToggle={(isOpen) =>
            !isOpen && params.search && changeParams({ search: '' })
          }
        />
      }
    >
      <BannedIpsTable
        asyncStatus={asyncStatus}
        hasPreviousPage={hasPreviousPage}
        hasNextPage={hasNextPage}
        previousPage={previousPage}
        nextPage={nextPage}
        refreshItems={refreshItems}
        items={items}
      />
    </Page.Section>
  );
}
